var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useClassNames } from '../../hooks/use-class-names';
import styles from './links.module.scss';
export var Link = function (_a) {
    var _b;
    var globalStyles = _a.cfg, _c = _a.underline, underline = _c === void 0 ? false : _c, className = _a.className, testId = _a.testId, children = _a.children, props = __rest(_a, ["cfg", "underline", "className", "testId", "children"]);
    var classNames = useClassNames(globalStyles, [
        styles.link,
        (_b = {}, _b[styles['link-underline']] = underline, _b),
        className,
    ]);
    var anchorProps = __assign({ 'data-testid': testId, className: classNames, href: props.href ? props.href : '#', onClick: null }, props);
    if (props.onClick && !props.href) {
        anchorProps.onClick = function (e) {
            props.onClick();
            e.preventDefault();
        };
    }
    return React.createElement('a', anchorProps, children);
};
//# sourceMappingURL=links.js.map